const homeLink = () => {
  if (
    typeof window !== 'undefined' &&
    window.location.origin.includes('localhost')
  ) {
    return '/next/home';
  }
  return '/';
};

const URL = {
  HOME: homeLink(),
  JOB_SEEKER: '/job-seeker',
  RECRUITERS: '/recruiters',
  FOR_RECRUITERS: '/for-recruiters',
  FIND_JOBS: '/find-jobs',
  MOCK_INTERVIEW: '/mockinterview',
  BLOG_PAGE: '/blog',
  PRICING_DASHBOARD: '/pricing-dashboard',
  EVENTS: '/events',
  FAQS: '/faqs',
  SEO_FIND_JOBS: '/find-jobs/:skillsAndLocations',
  FIND_JOBS_SEARCHES: '/find-jobs/searches',
  FIND_CANDIDATES: '/find-candidates',
  SEO_FIND_CANDIDATES: '/find-candidates/:skillsAndLocations',
  FIND_CANDIDATES_SEARCHES: '/find-candidates/searches',
  POST_JOB: '/postjob',
  CANDIDATE_PROFILE: '/candidate-profile-form',
  // FOR_EMPLOYER: '/company-profile',
  POSTED_JOBS: '/postedjobs',
  JOB_STATUS: '/job-status',
  ASSESSED_CANDIDATE: '/assessed-candidate',
  AI_ASSESSED_CANDIDATE: 'ai/assessed-candidate',
  EMPLOYER_PROFILE: '/company-profile',
  EMPLOYER_ASSESSMENTS: '/recuriter/assessments',
  AI_INTERVIEW: '/recuriter/aiinterviews',
  EMPLOYER_EDIT_ASSESSMENT: `/recuriter/edit-Assessment/`,
  AI_EMPLOYER_EDIT_ASSESSMENT: `/ai/recuriter/edit-Assessment`,
  AI_EMPLOYER_CREATE_ASSESSMENT: `/ai/recuriter/create-assessment`,
  EMPLOYER_CREATE_ASSESSMENT: `/recuriter/create-assessment`,
  COMPANY_EMPLOYEE_PROFILE: '/company-employee',
  EMPLOYER_DETAILS: '/employer-details',
  JOB_DETAILS: '/job-details',
  CANDIDATE_DETAILS: '/candidate-details',
  ASSESSMENT_DETAILS: '/assessment-details',
  EMPLOYER_META: '/employer/',
  JOB_META: '/job/',
  CANDIDATE_META: '/candidate/',
  ASSESSMENT_META: '/next/assessment/',
  MOCK_INTERVIEW_META: '/next/mockinterview/',
  PAYMENT: '/payment',
  MY_CANDIDATES: '/my-candidates',
  INVITE_CANDIDATES: '/invite-candidates',
  MY_JOBS: '/my-jobs',
  My_Profile_Activity: '/my-profile-Activity',
  LOGIN: '/login',
  OAUTH_LOGIN: '/oauth-login',
  REGISTER: '/register',
  VERIFY_EMAIL: '/verifyemail',
  CONFIRM_EMAIL: '/confirmemail',
  FORGOT_PASSWORD: '/forgotpassword',
  RESEND_EMAIL: '/resendemail',
  UPDATE_PASSWORD: '/updatepassword',
  CHANGE_PASSWORD: '/changepassword',
  CONFIRM: '/confirm',
  GUIDELINES: '/guidelines',
  ASSESSMENT: '/assessments',
  MY_ASSESSMENTS: '/my-assessments',
  AVAILABLE_ASSESSMENT: '/assessments?tab=available',
  SETTING: '/setting',
  OFFERS: '/offers',
  ALL_OFFERS: '/all-offers',
  START_ASSESSMENT: '/startassessment',
  INFORMATION: '/information',
  UNIV_STUDENTS: '/univ-students',
  NOTIFICATIONS: '/notifications',
  UNSUBSCRIBE: '/unsubscribe',
  ADMIN_ACTION: '/admin-actions',
  ADMIN_ANALYTICS: '/admin-analytics',
  ADMIN_WHATSAPP: '/admin/whatsapp',
  ADMIN_ALL_JOBS_POSTED: '/admin-all-jobs-posted',
  ADMIN_CANDIDATES_DETAILS: '/admin-candidates-details',
  PROJECT_DETAILS: '/project-details',
  MY_PROJECTS: '/my-projects',
  COMPANY_PROJECTS: '/company-projects',
  ASSESSMENT_REPORT: '/assessmentreport',
  UNSUBSCRIBE_EMAIL: '/unsubscribe',
  BLOG_DETAILS: '/blog-details',
  BLOG_META: '/next/blog/',
  CAREER_PATH: '/careerpath',
  CAREER_PATH_ACHEIEVED: '/careerpathAcheived',
  CANDIDATE_CERTIFICATES: '/candidate-certificates',
  RECOMMENDATIONS: '/recommendations',
  JOB_POSTING: '/next/job-posting',
  CREATE_INTERVIEW: '/next/create-interview',
  CREATE_ASSESSMENT: '/next/create-assessment',
  EMPLOYER_EVENTS: '/next/employer-events',
  CANDIDATE_ASSESSMENTS: '/next/candidate-assessments',
  CANDIDATE_EVENTS: '/next/candidate-events',
  MOCK_INTERVIEW_PAGE: '/next/mockinterview-page',
  AI_TOOLS: '/ai-tools',
};
export default URL;

const URL_TYPE = {
  CANDIDATE: 1,
  EMPLOYER: 2,
  COMMON: 3,
  PUBLIC: 4,
  UNIVERSITY: 5,
  ADMIN: 3,
};

export const ROLES_TYPES = {
  CANDIDATE: [URL_TYPE.CANDIDATE],
  EMPLOYER: [URL_TYPE.EMPLOYER],
  UNIVERSITY: [URL_TYPE.UNIVERSITY],
  COMMON: [
    URL_TYPE.CANDIDATE,
    URL_TYPE.EMPLOYER,
    URL_TYPE.UNIVERSITY,
    URL_TYPE.ADMIN,
  ],
  PUBLIC: [URL_TYPE.PUBLIC],
  ADMIN: [URL_TYPE.ADMIN],
};

export const employerUrls = new Set([
  URL.FIND_CANDIDATES,
  URL.FIND_CANDIDATES_SEARCHES,
  URL.RECRUITERS,
  URL.CANDIDATE_META,
  URL.LOGIN,
  URL.MY_CANDIDATES,
  URL.EMPLOYER_ASSESSMENTS,
  URL.EMPLOYER_PROFILE,
  URL.POSTED_JOBS,
  URL.POST_JOB,
  URL.AI_INTERVIEW,
  URL.PROJECT_DETAILS,
  URL.COMPANY_PROJECTS,
  URL.EMPLOYER_DETAILS,
]);

// Hook for getting video mappings based on interviewer voice
export const useVideoMappings = () => {
  const videoMappings = {
    onyx: {
      welcome: '/videos/onyx_welcome.mp4',
      talking: '/videos/onyx_talking.mp4',
      idle: '/videos/onyx_idle.mp4',
    },
    sage: {
      welcome: '/videos/sage_welcome.mp4',
      talking: '/videos/sage_talking.mp4',
      idle: '/videos/sage_idle.mp4',
    },
  };

  const getVideoSources = (interviewerVoice) =>
    videoMappings[interviewerVoice] || videoMappings.sage; // Default to sage if voice not found
  return { videoMappings, getVideoSources };
};
